import axios from 'axios'

/**
 * Before any API call, use the clientID required for the api
 **/
async function checkCredential(config) {
  if (!config.url.includes('apimanagerconsumercredentials')) {
    if (!window.api_credentials && !window.api_credentials_request) {
      window.api_credentials_request = axios
        .get('/portal/config/apimanagerconsumercredentials.json')
        .then(resp => (window.api_credentials = resp.data))
        .catch(err => console.log('Error fetching credentials ' + err))
    }
    await window.api_credentials_request
    config.headers.common['X-IBM-Client-Id'] = window.api_credentials?.clientId
  }

  return config
}

axios.interceptors.request.use(checkCredential)

export async function downloadMicrodataCSV(cardId, fileId, language) {
  let objectParams = new URLSearchParams()
  if (cardId) objectParams.append('id', cardId)
  if (fileId) objectParams.append('idResource', fileId)
  if (language) objectParams.append('language', language)
  const response = await axios
    .get(process.env.VUE_APP_API_URL + 'microdata/export', {
      params: objectParams,
    })
    .then(resp => {
      return resp.data
    })
    .catch(function () {
      return {
        code: 500,
      }
    })
  return response
}

export async function downloadStatisticsFile(cardId, type) {
  const params = new URLSearchParams()
  if (cardId) params.append('id', cardId)
  if (type) params.append('fileformat', type)

  return axios
    .get(process.env.VUE_APP_API_URL + 'statistic/export', {
      params,
      responseType: 'blob',
    })
    .then(resp => {
      const extension = type === 'CSV' ? 'csv' : 'xlsx'
      const blob = new Blob([resp.data])
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'Taula estadística.' + extension
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    })
    .catch(function () {
      return {
        code: 500,
      }
    })
}

/**
 * Descarga del ZIP generada en BACK.
 * Nota: este endpoint NO es el de auditoría/guardado en BBDD (save/download),
 * sino el que devuelve el binario.
 */
export async function downloadStatisticsZip(config) {
  return axios.post(process.env.VUE_APP_API_URL + 'api/stats/download/zip', config, {
    responseType: 'blob',
  })
}
